<template>
  <section class="page-instructor-request mt-3">
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="progress-up" v-if="uploadPercentage > 0 && uploadPercentage !==  100">
      <div class="parent-loading">
        <b-progress
          show-progress
          animated
          :value="uploadPercentage"
          class="mt-2 w-100"
          :variant="'info'"
        ></b-progress>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col">
          <header class="text-right mb-4">
            <h1 class="font-20">فرم در خواست تدریس</h1>
          </header>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="wrapper-form mb-3 shadow p-4">
            <div class="description-top">
              <p>از طریق فرم زیر می توانید درخواست همکاری در زمینه تدریس را برای مادیا ارسال نمایید. لطفا قبل از تکمیل و ارسال فرم به نکات زیر توجه نمایید.</p>
              <ul>
                <li>تکمیل پروفایل کاربری قبل از ارسال این فرم الزامی می باشد. در صورت تکمیل نبودن پروفایل فرم درخواست تدریس ارسال نمی گردد. کامل بودن پروفایل مدرس در جهت بهتر دیده شدن رزومه مدرس توسط مخاطبین و ارتباط تیم مادیا با مدرس می باشد.</li>
                <li>
                  قبل از ارسال فرم درخواست تدریس،
                  <router-link to="/v1/teaching?tabActive=3" target="_blank">
                    <span>لطفا استانداردهای کیفیت و تولید محتوا</span>
                  </router-link>
                  را که در
                  <router-link to="/v1/teaching" target="_blank"> <span> صفحه تدریس </span> </router-link>قرار دارد مطالعه فرمایید.
                </li>
                <li>
                  قبل از ارسال فرم درخواست تدریس، لطفا
                  <router-link to="/v1/terms-of-use" target="_blank">
                    <span>قوانین و مقررات مدرسان</span>
                  </router-link>را مطالعه فرمایید.
                </li>
                <li>
                  در صورت داشتن هرگونه سوال در مورد موارد فوق و یا
                  <router-link to="/v1/teaching?tabActive=1"  target="_blank">
                          <span>تعرفه های همکاری با مدرسین</span>
                  </router-link>
                  می توانید از طریق
                  <router-link to="/v1/about?tabActive=2" target="_blank">
                    <span>راه های ارتباطی با تیم مادیا</span>
                  </router-link>در ارتباط باشید.
                </li>
                <li>بعد از ارسال فرم درخواست تدریس، ویدئوی ارسالی و موضوع تدریس، بررسی و از طریق راه های ارتباطی موجود در پروفایل کاربری با شما ارتباط گرفته می شود.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="wrapper-form mb-3 shadow p-4">
            <div class="row">
              <div class="col-12 clearfix my-3">
                <div class="input-group mb-3">
                  <div class="custom-file">
                    <input
                      type="file"
                      v-validate="'required'"
                      accept="video/*"
                      class="custom-file-input"
                      id="test_video"
                      name="test_video"
                      @change="upload($event)"
                    >
                    <label
                      class="custom-file-label"
                      for="lecture_video"
                    >{{instructorForm.test_video ?instructorForm.test_video.name : 'آپلود ویدئو'}}</label>
                  </div>
                  <div class="input-group-prepend">
                    <span class="input-group-text">آپلود ویدئو</span>
                  </div>
                </div>
                <div class="group-form">
                  <span v-if="errors.has('test_video')" class="is-danger">فیلد نباید خالی باشد</span>
                </div>
                <div class="d-flex flex-row justify-content-start font-14">
                  <span class="ml-3">حجم فایل مجاز : 200 MB</span>
                  <span>فرمت های مجاز : .mp4</span>
                </div>
              </div>
              <div class="col-12 mt-3">
                <div class="group-form">
                  <textarea
                    maxlength="255"
                    type="text"
                    v-validate="'required'"
                    name="description"
                    :class="{active:instructorForm.description != '' }"
                    v-model="instructorForm.description"
                  ></textarea>
                  <span class="bar"></span>
                  <label class="statr">توضیحات</label>
                  <span v-if="errors.has('description')" class="is-danger">فیلد نباید خالی باشد</span>
                </div>
              </div>
              <div class="col-6">
                <div class="group-form">
                  <input
                    type="text"
                    v-validate="'required'"
                    name="category"
                    :class="{active:instructorForm.category != '' }"
                    v-model="instructorForm.category"
                  >
                  <span class="bar"></span>
                  <label class="statr">دسته فعالیت</label>
                  <span v-if="errors.has('category')" class="is-danger">فیلد نباید خالی باشد</span>
                </div>
              </div>
              <div class="col-12">
                <div class="text-left form-action mt-2">
                  <button
                    class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
                    v-ripple
                    @click="submitForm"
                  >ارسال اطلاعات</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="wrapper-form mb-3 shadow p-4">
            <div class="description-top">
            
            <p>راهنمای فرم درخواست تدریس</p>
            <ul>
              <li>
                در قسمت آپلود ویدئو، نمونه از ویدئو های آموزشی خود را در قالب فرمت Mp4 و با حداقل کیفیت 720P با حداکثر حجم 200 مگا بایت برای بررسی کیفیت ویدئو پیوست نمایید. این بررسی صرفا بر روی استانداردهای کیفیت و تولید محتوا از قبیل کیفیت تصویر، صدا و ... می باشد.
              </li>
              <li>
                در قسمت توضیحات می توانید خلاصه ای از رزومه و زمینه آموزشی – تخصصی خود و هر نکته ای که لازم می دانید که در مورد دوره های خود با تیم مادیا در میان بگذارید، وارد نمایید. 
              </li>
              <li>
                در قسمت دسته فعالیت، دسته بندی که دوره شما را شامل می شود وارد نمایید. مثال : مهندسی عمران – نرم افزار
              </li>
            </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "instructor-request",
  data() {
    return {
      isLoading: false,
      instructorForm: {
        test_video: "",
        description: "",
        category: ""
      }
    };
  },
  computed: {
    uploadPercentage() {
      return this.$store.state.InstructorForm.uploadPercentage;
    }
  },
  mounted() {
    this.checkBio();
  },
  methods: {
    async checkBio() {
      let data = await this.$store.dispatch("dashboardProfile/getBio");
      if (!data.bio.length) {
        this.$root.showWarnMsg({
          message: "ابتدا باید پروفایل خود را تکمیل کنید ..."
        });
        this.$router.push("/dashboard/profile?page=/v1/instructor-request");
      }
    },
    async upload(e) {
      var files = e.target.files[0];
      if (!files) return;
      let filesize = (files.size / 1024 / 1024).toFixed(2); // MB
      if (filesize > 200) {
        this.$root.showWarnMsg({
          message: "حجم فایل نباید بیشتر از ۲۰۰ مگابایات باشد... "
        });
        return;
      }
      this.instructorForm.test_video = files;
    },
    async submitForm() {
      let result = await this.$validator.validate();
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      this.isLoading = true;
      await this.$store.dispatch(
        "InstructorForm/submitForm",
        this.instructorForm
      );
      this.instructorForm = {
        test_video: "",
        description: "",
        category: ""
      };
      this.isLoading = false;
      this.$validator.reset();
    }
  }
};
</script>
<style lang="stylus">
.page-instructor-request
  .description-top
    p
      color #000
    ul
      padding-right 25px
      span
        background-color #fff2ac
        background-image linear-gradient(to right, #ffe359 0%, #fff2ac 100%)
    li
      margin-bottom 10px
      font-size 15px
      list-style arabic-indic
</style>



// WEBPACK FOOTER //
// src/pages/instructor-request.vue